import { render, staticRenderFns } from "./plant-index.vue?vue&type=template&id=5a433f6c&scoped=true&"
import script from "./plant-index.vue?vue&type=script&lang=js&"
export * from "./plant-index.vue?vue&type=script&lang=js&"
import style0 from "./plant-index.vue?vue&type=style&index=0&id=5a433f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a433f6c",
  null
  
)

export default component.exports